// Initial planning assumptions, not measured delivery commitments.
// Remote investigation, analysis, documentation, and readout per business.
const REMOTE_BUSINESS_DAYS = {
  focused: [5, 10],
  functional: [10, 20],
  full: { simple: [15, 25], standard: [20, 30], complex: [30, 40] }
};

// Accepts validated, priced items from calculatePortfolio. A single team
// completes businesses sequentially; onsite days belong to the entire item.
export function estimateItemTimeframe(item) {
  const range = item.assessmentType === 'full'
    ? REMOTE_BUSINESS_DAYS.full[item.complexity]
    : REMOTE_BUSINESS_DAYS[item.assessmentType];
  const minDays = range[0] * item.quantity + item.onsiteDays;
  const maxDays = range[1] * item.quantity + item.onsiteDays;
  return `${minDays.toLocaleString('en-US')}–${maxDays.toLocaleString('en-US')} business days`;
}

export const TIMING_ASSUMPTIONS = 'Timeframes are preliminary planning estimates for all businesses in each item, from that item’s kickoff through findings and readout. They assume one dedicated assessment team working sequentially, a five-day workweek, and prompt access to systems, documents, and stakeholders. Remote assessment time is multiplied by quantity; the item’s total onsite days are added once. Parallel teams may shorten delivery; scheduling gaps, travel, holidays, and delayed access or feedback may extend it. Item ranges are not a promised portfolio completion date. Confirm staffing, sequencing, and time for any shared industry or portfolio synthesis before agreeing the final schedule.';
